import { Api } from "../../Api";

export const getCollectionDetailsService = async (
  collectionId: string | undefined
) => {
  let url = `/collection/collection-detail/${collectionId}`;
  const response = await Api.get(url);
  return response;
};

export const getCollectionNFTsService = async (
  collectionId: string | undefined,
  limit: number = 10,
  page: number = 1,
  name: string = "",
  rank_by: string = ""
) => {
  let url = `/nft/get-nft-list/${collectionId}?limit=${limit}&page=${page}&`;

  if (name) {
    url += `name=${name}&`;
  }

  if (rank_by) {
    url += `rank_by=${rank_by}&`;
  }

  url = url.endsWith("&") ? url.slice(0, -1) : url;

  const response = await Api.get(url);
  return response;
};

export const searchCollectionNFTsService = async (
  collectionId: string | undefined,
  keyword: string = "",
  limit: number = 10,
  page: number = 1
) => {
  let url = `collection/nft-search?search=${keyword}&limit=${limit}&page=${page}&`;

  if (collectionId) {
    url += `collection_id=${collectionId}&`;
  }

  url = url.endsWith("&") ? url.slice(0, -1) : url;

  const response = await Api.get(url);
  return response;
};
